<template>
  <router-view />
</template>

<script>
import config from '@/config'

export default {
  title: config.title
}
</script>